import { isHotelPackage } from 'lib/offer/offerTypes'

// Match a line that starts with two asterisks, as that implies we're dealing with Markdown. For
// example: "\n**Size:** 165m²\n\n**Sleeps:** 4 guests\n\n**Partial sea view**\n".
const BEDBANK_RICH_DESC_REGEX = /^\*\*/m

/** Bedbank room tiles suppress the description inline whenever it's rich markdown (shown only in
 * a "View room details" modal instead) -- callers that only render plain visible text should use
 * this instead of the raw `description` field. */
export function bedbankPlainDescription(description: string | undefined): string | undefined {
  return description && !BEDBANK_RICH_DESC_REGEX.test(description) ? description : undefined
}

/** Room-type-group name wins when the room type belongs to a group -- the consistent precedence
 * used by every real room-name render path. */
export function getHotelRoomTypeName(roomType: App.HotelPackage['roomType']): string {
  return roomType.group?.name ?? roomType.name
}

export function mapRoomPackage<T>(
  roomPackage: App.Property.Room | App.HotelPackage | App.BedbankPackage,
  mapPropertyRoom: (room: App.Property.Room) => T,
  mapHotelPackage: (hotelPackage: App.HotelPackage) => T,
  mapBedbankPackage: (bedbankPackage: App.BedbankPackage) => T,
): T {
  // This isn't the most meaningful discriminator, but it does the job.
  if ('defaultOrder' in roomPackage) {
    return mapPropertyRoom(roomPackage)
  }
  if (isHotelPackage(roomPackage)) {
    return mapHotelPackage(roomPackage)
  }
  return mapBedbankPackage(roomPackage)
}
